import queryString from "query-string";

export const fetchUnvisitedPlacesNearby = (): Function => (
  state,
  actions,
): Promise<void> => {
  const {
    api,
    clientID,
    unvisitedPlaces: {
      category: { id: categoryID },
      keyword,
      coordinates,
      since,
      until,
      portifolio: { id: unvisitedPlacesPortifolioID },
    },
    unvisitedPlacesNearby: {
      pagination: { pageNumber, pageSize },
      radius,
      portifolio: { id: portifolioID },
    },
  } = state;

  const headers = new Headers({ authorization: state.authorization });
  const fetching = fetch(
    `${api}/v1/unvisited-places/${clientID}?${queryString.stringify({
      categoryID,
      coordinates: state.unvisitedPlaces.selectedPlace.coordinates,
      keyword,
      pageNumber,
      pageSize,
      portifolioID: portifolioID || unvisitedPlacesPortifolioID,
      radius: state.unvisitedPlaces.radius,
      since,
      until,
    })}`,
    { headers },
  );

  fetching
    .then(response => {
      if (!response.ok) {
        throw { reason: new Error(response.statusText) };
      }
      return response.json();
    })
    .then(({ places }) => {
      actions.setUnvisitedPlaces({
        pageNumber,
        pageSize,
        places,
        isLoaded: true,
      });
      actions.fetchUnvisitedPlacesNearbyCount({
        categoryID,
        coordinates: state.unvisitedPlaces.selectedPlace.coordinates,
        pageNumber,
        pageSize,
        portifolioID: portifolioID || unvisitedPlacesPortifolioID,
        radius: state.unvisitedPlaces.radius,
        since,
      });
    })
    .catch(reason => actions.setUnvisitedPlacesFailed({ reason }));

  return {
    ...state,
    unvisitedPlaces: {
      ...state.unvisitedPlaces,
      selectedPlace: { ...state.unvisitedPlaces.selectedPlace },
      loadingUnvisitedPlaces: true,
    },
  };
};
